import React from 'react';
import {ContentPanel} from '@taopix/taopix-design-system';
import Colour, {ColourProps} from '../BoxSettings/BoxSettingsOptions/Colour';
import {useTranslation} from 'react-i18next';
import useSettings from '../../../Hooks/useSettings';

type CalendarColourPaletteTypes = {
  selectedColour?: string;
} & Pick<ColourProps, 'onClick' | 'onRemoveColour'>;

const CalendarColourPalette = ({
  selectedColour,
  onRemoveColour,
  onClick,
}: CalendarColourPaletteTypes) => {
  const {t} = useTranslation();
  const settings = useSettings();

  const colours = settings.state.colours.palette;

  return (
    <ContentPanel className={'flex p-sm'}>
      <Colour
        id={'calendar-colour-picker'}
        sectionKey={'calendar-text-colour'}
        buttonLabel={t('str_TitleTextColour')}
        sectionTitle={t('str_TitleTextColour')}
        parentSection={'cell-editor-palette'}
        ignoreItem={true}
        colours={colours}
        selectedColour={selectedColour}
        onClick={onClick}
        allowRemoveColour
        onRemoveColour={onRemoveColour}
        preventManualUncheck
        smallScreenPanelHeight="full"
      />
    </ContentPanel>
  );
};

export default CalendarColourPalette;
